import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Drag&drop reordering for ProductModel gallery.
//
// Usage in ERB:
//   data-controller="image-gallery"
//   data-image-gallery-url-value="<%= reorder_admin_product_model_path(@product_model) %>"
//   data-image-gallery-csrf-value="<%= form_authenticity_token %>"
//
// Each item gets:
//   data-image-gallery-target="item"
//   data-image-id="<%= img.id %>"
//
// After drag-end, sends PATCH to URL with body { image_ids: [..] }.
export default class extends Controller {
  static targets = ["item"];
  static values = { url: String, csrf: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 150,
      ghostClass: "opacity-50",
      onEnd: this.persistOrder.bind(this),
    });
  }

  disconnect() {
    this.sortable?.destroy();
  }

  async persistOrder() {
    const imageIds = this.itemTargets
      .map((el) => el.dataset.imageId)
      .filter(Boolean);

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": this.csrfValue,
        },
        body: JSON.stringify({ image_ids: imageIds }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        console.error("Reorder failed:", data);
        alert(`Nie udało się zapisać kolejności: ${data.message || response.statusText}`);
      }
    } catch (error) {
      console.error("Reorder request error:", error);
      alert(`Błąd sieci przy zapisie kolejności: ${error.message}`);
    }
  }
}
